var React = require('react');

function Left (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Icons","transform":"translate(-80.000000, -842.000000)","fill":"#FFFFFF"},React.createElement("polygon",{"id":"left","points":"96 849 83.83 849 89.42 843.41 88 842 80 850 88 858 89.41 856.59 83.83 851 96 851"})))]);
}

Left.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = Left;

Left.default = Left;
